import { asPage } from 'src/components/hoc/asPage'
import { PasswordEditor } from 'src/compositions/Profile/Password'

export default asPage(PasswordEditor, { pageTitle: 'パスワード編集' })
